import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  description: {
    fontSize: 24,
    fontWeight: 'bold',
  },
}));
